import { usePageMeta } from "@/hooks/use-page-meta";

import HeroSection from "@/components/HeroSection";
import ProfileCarousel from "@/components/ProfileCarousel";
import AdvantagesSection from "@/components/AdvantagesSection";
import ConditionsSection from "@/components/ConditionsSection";
import ProcessSection from "@/components/ProcessSection";
import OpportunitiesSection from "@/components/OpportunitiesSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import ContactForm from "@/components/ContactForm";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";

const Index = () => {
  usePageMeta({ title: "Devenez Recruteur Indépendant - Work&You", description: "Changez de vie en devenant recruteur indépendant chez Work&You. Formation, accompagnement et liberté entrepreneuriale.", path: "/" });
  return (
    <div className="brand-page min-h-screen bg-background">
      <SiteHeader />
      <HeroSection />
      <div id="independants"><ProfileCarousel /></div>
      <div id="avantages"><AdvantagesSection /></div>
      <ConditionsSection />
      <div id="parcours"><ProcessSection /></div>
      <OpportunitiesSection />
      <TestimonialsSection />
      <ContactForm />
      <SiteFooter />
    </div>
  );
};

export default Index;
